/**
 * Recost design tokens — JS constants for use in inline styles.
 * Source of truth for colors is globals.css (:root CSS vars).
 * These constants mirror those vars for use where Tailwind classes can't reach.
 *
 * Primary accent: #F26B1D (bright orange) — brand color, CTAs, highlights.
 * Secondary accent: #1DF2D5 (teal) — gradient backgrounds only.
 * Theme: light, minimal, stone/zinc neutral palette.
 */

export const accent = '#F26B1D';
export const accentSecondary = '#1DF2D5';

export const colors = {
  // Accent (bright orange — brand)
  accent,
  accentSecondary,
  accentSubtle:  'rgba(242, 107, 29, 0.10)',
  accentBorder:  'rgba(242, 107, 29, 0.25)',
  accentHover:   'rgba(242, 107, 29, 0.16)',

  // Backgrounds (stone/zinc light)
  bgPage:    '#fafaf9',
  bgBase:    '#ffffff',
  bgSubtle:  '#f5f5f4',
  bgHeader:  '#ffffff',
  bgHover:   '#f5f5f4',

  // Borders
  borderSubtle:  '#e7e5e4',
  borderDefault: '#e7e5e4',
  borderHover:   '#d6d3d1',

  // Text — all pass WCAG AA on #fafaf9
  textPrimary:   '#0a0a0a',   // ~18:1
  textSecondary: '#57534e',   // stone-600
  textMuted:     '#78716c',   // stone-500

  // Semantic — error
  error:       '#ef4444',
  errorSubtle: 'rgba(239, 68, 68, 0.08)',
  errorBorder: 'rgba(239, 68, 68, 0.20)',

  // Semantic — warning
  warning:       '#F26B1D',
  warningSubtle: 'rgba(245, 158, 11, 0.06)',
  warningBorder: 'rgba(245, 158, 11, 0.20)',
} as const;

/** FADE animation preset — use for page-level entrance only, not per-item lists. */
export const FADE = (delay = 0) => ({
  initial:    { opacity: 0, y: 16 },
  animate:    { opacity: 1, y: 0 },
  transition: { duration: 0.4, delay, ease: [0.16, 1, 0.3, 1] as const },
});

